const API_URL = import.meta.env.VITE_API_URL || "";

/** Resolve stored filename or absolute URL for `<img src>` / Avatar `image`. */
export function getClientAvatarUrl(avatar?: string | null): string | undefined {
  const s = avatar?.trim();
  if (!s) return undefined;
  if (s.startsWith("http")) return s;
  return `${API_URL}/uploads/${s}`;
}
